import { render, staticRenderFns } from "./SellerSwiper.vue?vue&type=template&id=b112412a&"
import script from "./SellerSwiper.vue?vue&type=script&lang=js&"
export * from "./SellerSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports